import { DataSaverOnOutlined } from "@mui/icons-material";
import { Box, useMediaQuery } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import KebabDiningIcon from "@mui/icons-material/KebabDining";
import CategoryCreate from "pages/product_category/CategoryCreate";
import CategoryAndSubList from "pages/product_category/CategoryAndSubList";

const ProductCategories = () => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod={smallScreen ? "Category" : "Product category"}
        viewIcon={<KebabDiningIcon />}
        createIcon={<DataSaverOnOutlined />}
        createChildren={<CategoryCreate />}
        listChildren={<CategoryAndSubList />}
      />
    </Box>
  );
};

export default ProductCategories;
